import {debounce} from './utils';

function handlePageHeroBanner() { 
    const pageHeroBanner = document.querySelector('.hero-banner');
    const pageHeroBannerImage = document.querySelector('.hero-image');
    const bannerImagePath = document.querySelector('.banner-image-path');

    if (!bannerImagePath || !pageHeroBanner || !pageHeroBannerImage) {
        return;
    }

    function alignImagePath() {
        const heroBannerRect = pageHeroBanner.getBoundingClientRect();
        const pathRect = bannerImagePath.getBoundingClientRect();
        
        const pathCenterY = pathRect.top + (pathRect.height / 2);
        const heroBannerBottom = heroBannerRect.bottom;

        const offsetNeeded = heroBannerBottom - pathCenterY;
        const currentBottom = parseInt(getComputedStyle(pageHeroBannerImage).bottom) || 0;

        if (!pageHeroBannerImage.classList.contains("hero-image-rdn")) {
            pageHeroBannerImage.style.bottom = `${currentBottom - offsetNeeded + 90}px`;
        }
    }

    alignImagePath();

    window.addEventListener('resize', debounce(alignImagePath, 250));
}

window.addEventListener('DOMContentLoaded', () => {
    handlePageHeroBanner();
});
